var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus2 = function SvgPlus2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373635",
    fillRule: "evenodd",
    d: "M19.5 29a.5.5 0 0 0 1 0v-8.5H29a.5.5 0 0 0 0-1h-8.5V11a.5.5 0 0 0-1 0v8.5H11a.5.5 0 0 0 0 1h8.5z",
    clipRule: "evenodd"
  })));
};
export default SvgPlus2;